module.exports = __webpack_public_path__ + "img/billing.acc23afb.svg";